import { ReactNode } from 'react';

import {
  DropdownListMenuHolder,
  DropdownListMenuList,
} from './DropdownListMenu.styled';

type Props = {
  width?: number;
  height?: string;
  children: ReactNode;
  qaId: string;
};

export function DropdownListMenu({ width, height, children, qaId }: Props) {
  return (
    <DropdownListMenuHolder data-qa-id={qaId}>
      <DropdownListMenuList $width={width} $height={height}>
        {children}
      </DropdownListMenuList>
    </DropdownListMenuHolder>
  );
}
